import React from "react";
import { Route, Switch } from "react-router-dom";
import { AppRoutes } from "constants/routes";
import DocumentAuditTrailPage from "./DocumentAuditTrailPage";

const DocumentAuditTrailRouter = () => (
  <Switch>
    <Route
      exact
      path={AppRoutes.DocumentAuditTrail}
      component={DocumentAuditTrailPage}
    />
  </Switch>
);

export default DocumentAuditTrailRouter;
